















































import Vue from 'vue'
import { camelizeKeys } from '@/utils'

import ItemFactory from '../../elements/likert/ItemFactory'
import SurveyMixin from '../SurveyMixin'

const settings = camelizeKeys(require('./phq9.yml'))
const factory = new ItemFactory(settings)

export default Vue.extend({
  mixins: [SurveyMixin],
  data() {
    return {
      settings,
      items1Til9: factory.scanRange(1, 9),
      severityItem: factory.item('severityItem'),
      scale: settings.phq9Scale,
    }
  },
})
